import ConfirmCareTeamChange from './ConfirmCareTeamChange'

export default ConfirmCareTeamChange
